import { render, staticRenderFns } from "./ActivityTypeDetail.vue?vue&type=template&id=5790c74f&"
import script from "./ActivityTypeDetail.vue?vue&type=script&lang=js&"
export * from "./ActivityTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports